/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { JunitTestData } from './JunitTestData';
const JunitTestExtraParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('junit_test')],
    ['data', JunitTestData],
]);
export class JunitTestExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JunitTestExtraParser.decode(input).map(res => new JunitTestExtra(res));
    }
    static unsafeDecode(input) {
        return JunitTestExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JunitTestExtraParser.encode(data);
    }
    static schema() {
        return JunitTestExtraParser.schema();
    }
}
